/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import Direcao from '../../../../assets/logos/direcao-square.png'
import { BiNotepad } from 'react-icons/bi'
import { Container, ImageContainer, TextContainer } from './styles'
import history from '../../../../services/history'
import { BsFillStarFill, BsStar } from 'react-icons/bs'
import { useDispatch } from 'react-redux'
import { changeRecentPath } from 'store/modules/recentView/action'
import { FAVORITE_COURSE } from 'pages/Subscription/services'
import { mutate } from 'swr'

interface SubscriptionCourseCardProps {
  name: string
  icon: string
  numberOfModules: number
  courseId: string
  subscriptionId: string
  isFavorite: boolean
}

const SubscriptionCourseCard: React.FC<SubscriptionCourseCardProps> = ({
  name,
  icon,
  numberOfModules,
  courseId,
  isFavorite,
  subscriptionId,
}) => {
  const [favorite, setFavorite] = useState(isFavorite)
  const dispatch = useDispatch()

  const FavoriteIcon = useCallback(() => {
    return (
      <span style={{ cursor: 'pointer' }} onClick={() => updateFavorite('remove')}>
        <BsFillStarFill size={20} color="#FFD233" />
      </span>
    )
  }, [])

  useEffect(() => {
    setFavorite(isFavorite)
  }, [isFavorite])

  const NotFavoriteIcon = useCallback(() => {
    return (
      <span style={{ cursor: 'pointer' }} onClick={() => updateFavorite('add')}>
        <BsStar size={20} color="#FFD233" />
      </span>
    )
  }, [])

  const updateFavorite = useCallback((type: string) => {
    FAVORITE_COURSE(String(courseId), type, subscriptionId)
      .then(() => {
        mutate(`/course/favorite-courses/${subscriptionId}`)
        setFavorite(type === 'add' ? true : false)
      })
      .catch((err) => {
        console.error('ops! ocorreu um erro' + err)
      })
  }, [])

  const redirect = useCallback((_id) => {
    dispatch(changeRecentPath(`/subscription/${window.location.href.split('/').pop()}`))
    history.push(`/course/${_id}`)
  }, [])

  return (
    <>
      <Container>
        <div onClick={() => redirect(courseId)}>
          <ImageContainer>
            <img src={icon ? icon : Direcao} alt={name} />
          </ImageContainer>
        </div>
        <TextContainer onClick={() => redirect(courseId)}>
          <h2 title={name}>{name.length > 110 ? `${name.substring(0, 110)}...` : name}</h2>
          {numberOfModules ? <BiNotepad /> : ''}
          {numberOfModules ? (
            <span>
              {numberOfModules} módulo{`${numberOfModules > 1 ? 's' : ''}`}
            </span>
          ) : (
            ''
          )}
        </TextContainer>
        {favorite ? <FavoriteIcon /> : <NotFavoriteIcon />}
      </Container>
    </>
  )
}

export default SubscriptionCourseCard
